import Icn from "../UI/SharieIcn/SharieIcn"
import { Close as CloseIcon } from "@mui/icons-material"

const ModalCloseButton = ({ handleClose }) => {
  return <Icn tooltip='Close Modal' color='black' onClick={handleClose} icon={<CloseIcon />} />
}
export default ModalCloseButton
